<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование истории" : "Новая история"'
  )
  v-card
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs12)
          s-publish-date-status(
            :errors='errors'
            :model='item'
          )
        v-flex(xs12)
          v-text-field(
            :error='errors.has("name")'
            :error-messages='errors.first("name")'
            v-model='item.name'
            label='Название / ФИО'
          )
        v-flex(xs12)
          v-text-field(
            :error='errors.has("comment")'
            :error-messages='errors.first("comment")'
            v-model='item.comment'
            label='Комментарий / Должность'
          )
        v-flex(xs12)
          v-textarea(
            :error='errors.has("annotation")'
            :error-messages='errors.first("annotation")'
            v-model='item.annotation'
            label='Аннотация для списка'
          )
        v-flex(xs12)
          div(class='subheading font-weight-medium mb-3') История успеха
          ckeditor(v-model='item.body')
        v-flex(xs12 sm4)
          s-image-upload(
            :src='item.picture_url'
            v-model='item.picture'
            label='Картинка новости'
          )

    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        @click='onSave'
        :loading='isLoading'
        color='primary'
        depressed
      ) Сохранить
</template>

<script>
import { createFormData } from '@/utils'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['id'],

  components: {
    Ckeditor: () => import('@/components/async/Ckeditor')
  },

  data: () => ({
    item: {},
    editor: true
  }),

  async created() {
    if (!this.id) return
    this.updateItem()
  },

  methods: {
    async updateItem() {
      this.item = (await this.fetchSingle({ id: this.id })).data
    },

    async onSave() {
      let data = createFormData(this.item)
      data.append('picture', this.item.picture)

      try {
        if (this.id) {
          await this.update({ id: this.id, data })
        } else {
          await this.create({ data })
        }
        this.$root.showSnack('История сохранена')
        this.$router.push({ name: 'Job.Stories' })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    ...mapActions('job/stories', ['fetchSingle', 'update', 'create']),
  },

  computed: {
    ...mapGetters('job/stories', ['isLoading'])
  }
}
</script>

<style>
.small textarea {
  font-size: 12px;
}
</style>
